const S = "https://partoo-media.s3.eu-west-1.amazonaws.com/assets/common", T = `${S}/illustration`, o = `${S}/appicons`, s = `${S}/partners`, A = `${S}/providers`, t = `${S}/logos`, _ = `${S}/covers`, c = `${S}/fallback`;
export {
  o as STATIC_APP_ICONS_ASSET,
  S as STATIC_COMMON_ASSET,
  _ as STATIC_COVERS_ASSET,
  c as STATIC_FALLBACK_ASSET,
  T as STATIC_ILLUSTRATION_ASSET,
  t as STATIC_LOGOS_ASSET,
  s as STATIC_PARTNERS_ASSET,
  A as STATIC_PROVIDERS_ASSET
};
